module.exports = __webpack_public_path__ + "img/i-upload.131e48de.png";